import React from 'react';
import _ from 'lodash';

import {
  UserStatusName,
  useUserStatusSelectFieldQuery
} from 'generated/graphql';



export interface IUserStatus {
  id: UserStatusName;
  displayName: string;
}

export interface IData {
  objects: IUserStatus[];
}

export function useQuery() {
  const queryTuple = useUserStatusSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.userStatuses ?? [], (node): IUserStatus => ({
        id: node.name,
        displayName: node.displayName
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
